import * as r from "restructure";
var EndOfImageMarker = {
  name: function name() {
    return "EOI";
  },
  afterEOI: new r.Reserved(r.uint8, Infinity)
};
export default EndOfImageMarker;